require('./bootstrap');

// Sweetalert 2
import Swal from 'sweetalert2/dist/sweetalert2'
window.SwalWithDefaults = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-primary",
        denyButton: "btn btn-danger mr-3",
        cancelButton: "btn btn-light mr-3",
    },
    buttonsStyling: false
});

// isotope mansory
import Isotope from 'isotope-layout';

// moment
import moment from 'moment';
window.moment = moment;

// Select2
import select2 from "select2";
window.select2 = select2;
$.fn.select2.defaults.set("theme", "bootstrap4");

import toastr from "toastr";
window.toastr = toastr;

const Fancybox = require('@fancyapps/fancybox');
window.Fancybox = Fancybox;

import "jquery-ui/ui/widgets/datepicker";

require( 'jquery-circle-progress');

window.dataTableDefaultConfig = {
    "dom": '<"row top"<"col-md-6"i><"col-md-6 text-left"f>>r<"table-responsive"t><"row bottom mt-4"<"col-md-6"l><"col-md-6"p>><"clear">',
    "autoWidth": false,
    "info": true,
    "stateSave": true,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    }
};

window.dataTableOrderConfig = {
    "dom": '<"row top">r<"table-responsive"t><"row bottom mt-4"<"col-4 col-xl-6"l><"col-8 col-xl-6"p>><"clear">',
    "autoWidth": false,
    "info": true,
    "stateSave": true,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "https://cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    }
};

window.addEventListener('livewire-alert', event => {
    toastr[event.detail.type](event.detail.message,
        event.detail.title ?? ''), toastr.options = {
        "closeButton": true,
        "progressBar": true,
    }
});

window.addEventListener('livewire-swal', event => {
    SwalWithDefaults.fire({
        title: event.detail.title ?? '',
        text: event.detail.text ?? '',
        icon: event.detail.icon ?? null,
    });
});

window.addEventListener('confirm-min-price', event => {
    SwalWithDefaults.fire({
        title: event.detail.title,
        html: event.detail.text,
        showCancelButton: true,
        confirmButtonText: 'Prosegui',
        cancelButtonText: 'Annulla',
        reverseButtons: true,
    }).then((result) => {
        if (!result.isConfirmed) {
            Livewire.find( event.detail.wire_id ).set('cart.'+event.detail.article_id+'.forcedPrice', event.detail.article_price);
        }
    });
});

window.addEventListener('request-accounting', event => {
    SwalWithDefaults.fire({
        title: event.detail.title ?? '',
        text: event.detail.text ?? '',
        icon: event.detail.icon ?? null,
        showCancelButton: true,
        confirmButtonText: 'Richiedi Scadenzario',
        cancelButtonText: 'Ignora',
        reverseButtons: true,
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                method: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: event.detail.endpoint.route,
                data: JSON.stringify({
                    'customer_id': event.detail.endpoint.customer_id,
                    'user_id': event.detail.endpoint.user_id,
                }),
                success: function(data) {
                    SwalWithDefaults.fire({
                        text: 'Scadenzario richiesto correttamente'
                    })
                },
                error: function(data) {
                    SwalWithDefaults.fire({
                        icon: 'error',
                        title: 'Errore...',
                        text: 'Richiesta Scadenzario fallita. Riprova in seguito',
                    })
                }
            });
        }
    });
});

function compareDates(startDate, endDate, format) {
    var temp, dateStart, dateEnd;
    try {
        dateStart = $.datepicker.parseDate(format, startDate);
        dateEnd = $.datepicker.parseDate(format, endDate);
        if (dateEnd < dateStart) {
            temp = startDate;
            startDate = endDate;
            endDate = temp;
        }
    } catch (ex) {}
    return {
        start: startDate,
        end: endDate
    };
}

$.fn.dateRangePicker = function(options) {
    options = $.extend(
        {
            changeMonth: false,
            changeYear: false,
            numberOfMonths: 2,
            rangeSeparator: " - ",
            useHiddenAltFields: false,
            closeText: 'Chiudi',
            prevText: 'Prec',
            nextText: 'Succ',
            currentText: 'Oggi',
            firstDay: 1,
            monthNames: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno', 'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
            monthNamesShort: ['Gen','Feb','Mar','Apr','Mag','Giu', 'Lug','Ago','Set','Ott','Nov','Dic'],
            dayNames: ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
            dayNamesShort: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],
            dayNamesMin: ['Do','Lu','Ma','Me','Gio','Ve','Sa'],
        },
        options || {}
    );

    var myDateRangeTarget = $(this);
    var onSelect = options.onSelect || $.noop;
    var onClose = options.onClose || $.noop;
    var beforeShow = options.beforeShow || $.noop;
    var beforeShowDay = options.beforeShowDay;
    var lastDateRange;

    function storePreviousDateRange(dateText, dateFormat) {
        var start, end;
        dateText = dateText.split(options.rangeSeparator);
        if (dateText.length > 0) {
            start = $.datepicker.parseDate(dateFormat, dateText[0]);
            if (dateText.length > 1) {
                end = $.datepicker.parseDate(dateFormat, dateText[1]);
            }
            lastDateRange = {
                start: start,
                end: end
            };
        } else {
            lastDateRange = null;
        }
    }

    options.beforeShow = function(input, inst) {
        var dateFormat = myDateRangeTarget.datepicker(
            "option",
            "dateFormat"
        );
        storePreviousDateRange($(input).val(), dateFormat);
        beforeShow.apply(myDateRangeTarget, arguments);
    };

    options.beforeShowDay = function(date) {
        var out = [true, ""],
            extraOut;
        if (lastDateRange && lastDateRange.start <= date) {
            if (lastDateRange.end && date <= lastDateRange.end) {
                out[1] = "ui-datepicker-range";
            }
        }

        if (beforeShowDay) {
            extraOut = beforeShowDay.apply(myDateRangeTarget, arguments);
            out[0] = out[0] && extraOut[0];
            out[1] = out[1] + " " + extraOut[1];
            out[2] = extraOut[2];
        }
        return out;
    };

    options.onSelect = function(dateText, inst) {
        var textStart;
        if (!inst.rangeStart) {
            inst.inline = true;
            inst.rangeStart = dateText;
        } else {
            inst.inline = false;
            textStart = inst.rangeStart;
            //if (textStart !== dateText) // enable this only for range
            {
                var dateFormat = myDateRangeTarget.datepicker(
                    "option",
                    "dateFormat"
                );
                var dateRange = compareDates(
                    textStart,
                    dateText,
                    dateFormat
                );
                myDateRangeTarget.val(
                    dateRange.start + options.rangeSeparator + dateRange.end
                );
                inst.rangeStart = null;
                if (options.useHiddenAltFields) {
                    var myToField = myDateRangeTarget.attr("data-to-field");
                    var myFromField = myDateRangeTarget.attr("data-from-field");
                    $("." + myFromField).val(dateRange.start).change();
                    $("." + myToField).val(dateRange.end).change();
                }
            }
        }
        onSelect.apply(myDateRangeTarget, arguments);
    };

    options.onClose = function(dateText, inst) {
        if(dateText=='') {
            if (options.useHiddenAltFields) {
                var myToField = myDateRangeTarget.attr("data-to-field");
                var myFromField = myDateRangeTarget.attr("data-from-field");
                $("." + myFromField).val('');
                $("." + myToField).val('');
            }
        }
        inst.rangeStart = null;
        inst.inline = false;
        onClose.apply(myDateRangeTarget, arguments);
    };

    return this.each(function() {
        if (myDateRangeTarget.is("input")) {
            myDateRangeTarget.datepicker(options);
        }
        myDateRangeTarget.wrap('<div class="dateRangeWrapper"></div>');
    });
};

$(function () {

    if(typeof Livewire !== 'undefined') {
        // Livewire before callback
        Livewire.on('confirm', e =>{
            SwalWithDefaults.fire({
                title: 'Sei sicuro?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla',
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    Livewire.find(e.component_id)[e.callback](...e.argv)
                }
            });
        });

        Livewire.on('confirmChangeCustomer', e =>{
            console.log('confirmChangeCustomer');
            SwalWithDefaults.fire({
                title: 'Attenzione',
                text: 'Selezionando questo cliente cambia la valuta e il tuo carrello verrà cancellato',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla',
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    Livewire.find(e.component_id)[e.callback](...e.argv)
                }
            });
        });
    }

    let circle_config = {
        fill:                { color: getCircleColor($('#circle-points').data('total-point')) },
        startAngle:          -Math.PI/2,
        animationStartValue: 0,
        //animation: false,
        thickness:           25,
        size:                120,
        reverse:             false
    };
    $('#circle-points').circleProgress(circle_config);

    window.addEventListener('refresh_circle_points', event => {
        var instance = $('#circle-points').data('circle-progress');
        if(instance) {
            circle_config['fill']['color'] = getCircleColor(event.detail.cart_total_points)

            let animationStartValue = $('#circle-points').circleProgress('value');
            $('#circle-points').circleProgress({
                animationStartValue: animationStartValue,
                value: event.detail.point_progress_perc,
            });
            $('#circle-points .point').html( event.detail.cart_total_points );
        } else {
            circle_config['fill']['color'] = getCircleColor($('#circle-points').data('total-point'));
            $('#circle-points').circleProgress(circle_config);
        }
    });

    function getCircleColor(point) {
        if(point<=999) {
            return '#cd7f32';
        } else if(point<=1999) {
            return '#C0C0C0';
        } else if(point<=2999) {
            return '#FFD700';
        } else {
            return '#ed202e';
        }
    }

    if($('.isotope').length>0) {
        var isotope = new Isotope( document.querySelector('.isotope'), {
            itemSelector: '.isotope-element',
            layoutMode: 'masonry',
            percentPosition: true,
            resizesContainer: true,
            resizable: true,
            mansory: {
                columnWidth: 1
            }
        });
    }

    $('[data-toggle="tooltip"]').tooltip()

    // reset button on datatable filter
    $('.datatable-search-form').on('click', '.btn-reset', function() {
        $(this).parent().find('input').val('').trigger('keyup').trigger('change');
    });
    $('.datatable-search-form').on('click', '.btn-reset-all', function() {
        let form = $(this).closest('.datatable-search-form');
        form.find('input').val('').trigger('keyup').trigger('change');
        form.find('select').val('').change();
    });

    $(".dateRangeField").each(function() {
        $( this ).dateRangePicker({
            showOn: "focus",
            rangeSeparator: " - ",
            dateFormat: "dd/mm/yy",
            useHiddenAltFields: true,
            constrainInput: true
        });
    });

    // expand order tracking section
    $('.dataTable').on('click', '.show-tracking', function() {
        $('.tracking-section-'+$(this).data('id')).toggleClass("d-none");
    });

    // confirm before delete
    $('body').on('click', '.generic.with-confirm', function(event) {
        event.preventDefault();
        let href = $(this).attr('href');
        SwalWithDefaults.fire({
            title: 'Sei sicuro di voler procedere?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                window.location = href;
            }
        });
    });

});


/**
 * Custom Plus / Minus button on quantity fields
 *
 * Button listeners are initialized with custom events that are:
 * selectFamily, selectArticle, searchResults, loadCart
 * Those can be fired both from livewire components or blade templates
 *
 */
['selectFamily', 'selectArticle', 'searchResults', 'loadCart'].forEach(function(e){

    document.addEventListener(e, function(e) {
        let quantityButtons = document.querySelectorAll('.input-group-quantity button');
        console.log(e);

        if (quantityButtons) {
            quantityButtons.forEach((element) => {

                element.addEventListener('click', (e) => {
                    e.stopPropagation();

                    var field = e.currentTarget.parentNode.querySelector('input[type="number"]');
                    var val = parseInt(field.value);
                    var max = parseInt(field.getAttribute('max'));
                    var min = parseInt(field.getAttribute('min'));
                    var step = parseInt(field.getAttribute('step'));
                    // console.log('Quantity: '+val+', Min: '+min+', Max: '+max+', Step: '+step);

                    // plus
                    if (e.currentTarget.classList.contains('plus')) {
                        if (max) {
                            field.value = (val + step) >= max ? max : (val + step);
                        } else {
                            field.value = val + step;
                        }
                    // minus
                    } else {
                        if (min) {
                            field.value = (val - step) <= min ? min : (val - step);
                        } else {
                            field.value = (val - step) > 0 ? (val - step) : 0;
                        }
                    }

                    // trigger livewire on input field
                    var livewireTriggerEvent = new Event('change');
                    field.dispatchEvent(livewireTriggerEvent);
                });
            });
        }

    })
});
